/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsUserControllerFindAllPaginatedQueryResponse,
  TelegramProductsUserControllerFindAllPaginatedQueryParams,
  TelegramProductsUserControllerFindAllPaginated401,
} from '../../types/TelegramProductsUserControllerFindAllPaginated.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramProductsUserFindAllPaginated } from '../../methods/telegramProductsUserFindAllPaginated.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramProductsUserFindAllPaginatedQueryKey = (
  params?: TelegramProductsUserControllerFindAllPaginatedQueryParams,
) => [{ url: '/api/user/telegram/products/paginated' }, ...(params ? [params] : [])] as const;

export type TelegramProductsUserFindAllPaginatedQueryKey = ReturnType<
  typeof telegramProductsUserFindAllPaginatedQueryKey
>;

export function telegramProductsUserFindAllPaginatedQueryOptions(
  params?: TelegramProductsUserControllerFindAllPaginatedQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramProductsUserFindAllPaginatedQueryKey(params);
  return queryOptions<
    TelegramProductsUserControllerFindAllPaginatedQueryResponse,
    ResponseErrorConfig<TelegramProductsUserControllerFindAllPaginated401>,
    TelegramProductsUserControllerFindAllPaginatedQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramProductsUserFindAllPaginated(params, config);
    },
  });
}

/**
 * {@link /api/user/telegram/products/paginated}
 */
export function useTelegramProductsUserFindAllPaginated<
  TData = TelegramProductsUserControllerFindAllPaginatedQueryResponse,
  TQueryData = TelegramProductsUserControllerFindAllPaginatedQueryResponse,
  TQueryKey extends QueryKey = TelegramProductsUserFindAllPaginatedQueryKey,
>(
  params?: TelegramProductsUserControllerFindAllPaginatedQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramProductsUserControllerFindAllPaginatedQueryResponse,
        ResponseErrorConfig<TelegramProductsUserControllerFindAllPaginated401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramProductsUserFindAllPaginatedQueryKey(params);

  const query = useQuery(
    {
      ...telegramProductsUserFindAllPaginatedQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramProductsUserControllerFindAllPaginated401>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
